The list of feature codes to disable for this hirer.

Currently, one disabled feature code is defined:

- `CandidateVerification` disables the Verify with SEEK Pass functionality for the hirer.
